export const SHOW_LIST_CONTENT = 'SHOW_LIST_CONTENT';
export const showListContent = () => ({
    type: SHOW_LIST_CONTENT,
});

export const HIDE_LIST_CONTENT = 'HIDE_LIST_CONTENT';
export const hideListContent = () => ({
    type: HIDE_LIST_CONTENT,
});
